import { useMemo } from "react";
import { useMatches, type Params, type UIMatch } from "react-router";

type Title = React.ReactNode | ((data: unknown) => React.ReactNode);
type BackLink = (params: Params<string>) => string;

function findHandle<T>(matches: UIMatch[], key: string) {
  const match = matches.find(
    (m) => !!m.handle && typeof m.handle === "object" && key in m.handle,
  );
  return match && { match, value: (match.handle as Record<string, T>)[key] };
}

/** Reads the `title` and `backLink` that routes declare in their `handle`. */
export function useRouteHeader() {
  const matches = useMatches();

  return useMemo(() => {
    const title = findHandle<Title>(matches, "title");
    const backLink = findHandle<BackLink>(matches, "backLink");
    return {
      title:
        typeof title?.value === "function"
          ? title.value(title.match.data)
          : title?.value,
      backTo: backLink?.value(matches.at(-1)?.params ?? {}),
    };
  }, [matches]);
}
